<template>
  <CardSeplag titulo="FILTRAR">
    <div style="display: flex;">
      <Rotulo cols="12 10" nome="DRE">
        <Dropdown  v-model="dreSelecionada" :options="listaDre" optionLabel="descUnidade" placeholder="Selecione..."
          @change="dreSelecionadaChange()" />
      </Rotulo>
      <Rotulo cols="12 10" nome="Nome">
        <InputText v-model="searchQuery" type="text" placeholder="Digite sua pesquisa..." @change="search()" />
      </Rotulo>
      <Rotulo cols="12 4">
        <Button label="Pesquisar" style="margin-left: 10px; margin-top: 16.5px;" @click="search()" />
      </Rotulo>
    </div>

    <div class="p-col-12" v-if="listaEscolasDreTabela.length > 0">
      <DataTable :value="listaEscolasDreTabela" :paginator="true" :rows="10"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        selectionMode="multiple">
        <Column field="codSeap" header="SEAP"></Column>
        <Column field="descUnidade" header="UNIDADE"></Column>
        <Column field="descDre" header="DRE"></Column>
        <Column header="SELECIONADOS" headerStyle="width:7%;" :bodyStyle="'text-align: center;'">
          <template #body="slotProps">
            <Checkbox :value="slotProps.data" v-model="escolasSelecionadas" :disabled="!isSelectable(slotProps.data)" />
          </template>
        </Column>
      </DataTable>
    </div>

    <div class="p-col-12 p-md-2" style="text-align: right; margin-top: 1rem;" v-if="listaEscolasDreTabela.length > 0">
      <Button label="Salvar" class="p-button-success" icon="pi pi-save" @click="salvarEscolasDre()" />
    </div>

  </CardSeplag>
</template>



<script>
import CardSeplag from '@/template/CardSeplag.vue'
import Rotulo from '@/template/RotuloSeplag.vue'
import { baseApiUrl } from '@/config/global'


export default {
  name: 'setorDRE',
  components: { CardSeplag, Rotulo },
  data() {
    return {
      listaDre: [],
      dreSelecionada: null,
      listaEscolasDre: [],
      listaEscolasDreTabela: [],
      escolasSelecionadas: [],
      escolasSelecionadasOld: [],
      searchQuery: ''
    }
  },
  async created() {
     await this.carregarDados();     
  },
  methods: {
    async carregarDados() {
      try {
        const dreResponse = await this.$http.get(`${baseApiUrl}/dre/all`);
        this.listaDre = dreResponse.data;      

        if (this.listaDre.length > 0) {
          this.dreSelecionada = this.listaDre[0];
          this.dreSelecionadaChange();
        }

        const escolasDreResponse = await this.$http.get(`${baseApiUrl}/escolaDre/all`);
        this.listaEscolasDre = escolasDreResponse.data;
        this.listaEscolasDreTabela = this.listaEscolasDre;

        this.escolasSelecionadasOld = this.listaEscolasDre.filter(item => item.selecionado)
        this.escolasSelecionadas = this.listaEscolasDre.filter(item => item.selecionado);
      } catch (error) {
        console.error('Erro ao carregar os dados:', error);
      }
    },
    async salvarEscolasDre() {
      this.escolasSelecionadas.forEach(escola => {
        if(escola.idDre === null ){
          escola.idDre = this.dreSelecionada.id
        }
        escola.selecionado = true
      });
      this.escolasSelecionadasOld.forEach(escolaOld => {
        const exists = this.escolasSelecionadas.some(escola => escola.idEscola === escolaOld.idEscola);
        if (!exists) {          
          escolaOld.selecionado = false;
          this.escolasSelecionadas.push(escolaOld);
        }
      });
      try {
        const res = await this.$http.post(`${baseApiUrl}/escolaDre/atualizarEscolaDre`, JSON.stringify(this.escolasSelecionadas));
        this.$toast.add({ severity: 'success', summary: 'Ação Efetuada', detail: res.data, life: 5000 });        
        await this.carregarDados();
      } catch (error) {
        console.error("Erro ao salvar Escolas - DRE:", error);
      }
    },
    search() {
      this.listaEscolasDreTabela = this.listaEscolasDre.filter((escola) => {
        const nomeEscola = escola.descUnidade.toLowerCase().includes(this.searchQuery.toLowerCase()) || escola.codSeap == this.searchQuery;
        return nomeEscola;
      });

    },
    isSelectable(escola) {
      if (this.dreSelecionada !== null) {
        return escola.descDre === null || escola.descDre === this.dreSelecionada.descUnidade;
      } else {
        return false;
      }

    },
    dreSelecionadaChange() {
    }
  },
  mounted() {
      
  }
}
</script>

<style scoped>

</style>